/**
 * 再資源化
 * 再資源化等パターン 検索条件保持
 */
import * as types from "../../../mutation-types/driver-types";

const getDefaultState = () => {
  return {
    condition: {
      /**
       * 選択種別
       * method: 処分場処理方法
       * flow: 処理フロー
       * @type { String }
       */
      selectable_menu: 'method',
      /**
       * パターン名
       * @type { String|null }
       */
      pattern_name: null,
       /**
       * 処分事業者ID
       * @type { Number|null }
       */
      disposer_id: null,
      /**
       * 処分事業場ID
       * @type { Number|null }
       */
      disposer_location_id: null,
      /**
       * 処分事業場コード
       * @type { String|null }
       */
      disposer_location_code: null,
      /**
       * 処理後物の大分類名
       * @type { Array }
       */
      disposal_category_codes: [],
      /**
       * 処理後物の種類
       * @type { Array }
       */
      disposal_subcategory_ids: [],
      /**
       * 処分方法名
       * @type { String|null }
       */
      recycle_disposal_method_name: null,
      /**
       * 処分方法
       * @type { Array|[] }
       */
      after_disposal_method_ids: [],
      /**
       * 非表示を表示しない
       * @type { Boolean }
       */
      without_invisible: true,
      /**
       * 一覧表示件数
       * @type { Number }
       */
      limit: 50,
    },
  };
};

const recycle_disposal_pattern_condition = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {

    /**
     * 検索条件の保存
     * @param param0
     * @param param0.commit
     * @param param0.state { Object }
     * @param param1
     * @param param1.condition { Object }
     * @property param0.state.condition 検索条件
     */
    saveCondition ( { commit, state }, { condition } = {} ) {
      const _selectable_menu = (condition.selectable_menu !== undefined) ? condition.selectable_menu : state.condition.selectable_menu;
      const _pattern_name = (condition.pattern_name !== undefined) ? condition.pattern_name : state.condition.pattern_name;
      const _disposer_id = (condition.disposer_id !== undefined) ? condition.disposer_id : state.condition.disposer_id;
      const _disposer_location_id = (condition.disposer_location_id !== undefined) ? condition.disposer_location_id : state.condition.disposer_location_id;
      const _disposer_location_code = (condition.disposer_location_code !== undefined) ? condition.disposer_location_code : state.condition.disposer_location_code;
      const _disposal_category_codes = (condition.disposal_category_codes !== undefined) ? condition.disposal_category_codes : state.condition.disposal_category_codes;
      const _disposal_subcategory_ids = (condition.disposal_subcategory_ids !== undefined) ? condition.disposal_subcategory_ids : state.condition.disposal_subcategory_ids;
      const _recycle_disposal_method_name = (condition.recycle_disposal_method_name !== undefined) ? condition.recycle_disposal_method_name : state.condition.recycle_disposal_method_name;
      const _after_disposal_method_ids = (condition.after_disposal_method_ids !== undefined) ? condition.after_disposal_method_ids : state.condition.after_disposal_method_ids;
      const _without_invisible = (condition.without_invisible !== undefined) ? condition.without_invisible : state.condition.without_invisible;
      const _limit = (condition.limit !== undefined) ? condition.limit : state.condition.limit;
      const params = {
        selectable_menu: _selectable_menu,
        pattern_name: _pattern_name,
        disposer_id: _disposer_id,
        disposer_location_id: _disposer_location_id,
        disposer_location_code: _disposer_location_code,
        disposal_category_codes: _disposal_category_codes,
        disposal_subcategory_ids: _disposal_subcategory_ids,
        recycle_disposal_method_name: _recycle_disposal_method_name,
        after_disposal_method_ids: _after_disposal_method_ids,
        without_invisible: _without_invisible,
        limit: _limit,
      }
      commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_CONDITION, { params })
    },
    resetState({ commit }) {
      commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_RESET_CONDITION);
    },
  },
  mutations: {
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_CONDITION](state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_RESET_CONDITION](state) {
      Object.assign(state, getDefaultState());
    },
  },
};

export default recycle_disposal_pattern_condition;
